import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'

const TopBar = ({ options, handleChange, value }) => {
  const handleOnChange = ({ target }) => {
    handleChange(parseInt(target.value))
  }

  return (
    <Form className="row row-cols-2">
      <Form.Label className="col-12 col-sm-3 col-form-label text-start text-sm-center"><strong>Location:</strong></Form.Label>
      <div className="col-12 col-sm-9">
        <Form.Control bsPrefix={'form-select'} as="select" defaultValue={value ? value : ''} onChange={handleOnChange}>
          <option key='all' value={''}>All</option>
          {options.map((v, k) => <option key={k} value={v.id}>{v.label}</option>)}
        </Form.Control>
      </div>
    </Form>
  )
}

TopBar.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.number,
  handleChange: PropTypes.func.isRequired
}

export default TopBar
